
<template>
  <v-card>
    <v-card-title primary-title>
      <div style="width: 100%">Saved Screens</div>
      <div class="caption grey--text text--darken-1">
        Reuse some filters very often? Save them as a screen & access it easily
      </div>
      <v-spacer></v-spacer>
      <v-btn
        small
        color="primary"
        outlined
        @click="loadScreener('BASIC', 'New Screen', false)"
        >New Screen</v-btn
      >
    </v-card-title>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12" sm="6" v-for="(col, i) in cols" :key="`ps-${i}`">
          <v-list class="" two-line>
            <v-list-item
              :key="screen.slug"
              v-for="screen in col"
              @click="loadScreener(screen.slug, screen.name, true)"
            >
              <!-- <v-icon left color="primary">mdi-lock-outline</v-icon> -->
              <v-list-item-content>
                <div>
                  {{ screen.name }}
                  <v-icon
                    v-show="selectedSlug == screen.slug"
                    small
                    color="primary"
                  >
                    mdi-checkbox-marked-circle-outline</v-icon
                  >
                </div>
                <div class="grey--text caption">{{ screen.description }}</div>
              </v-list-item-content>
              <v-btn
                icon
                small
                color="primary"
                @click.stop.prevent="deleteReport(screen.slug)"
              >
                <v-icon small> mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SavedScreens",
  props: {
    open: { type: Boolean },
  },
  data: () => ({
    screens: [],
  }),
  methods: {
    loadScreener(slug, name, custom) {
      this.$store.commit("setScreener", { slug, name, custom });
      this.$emit("update:open", false);
    },
    deleteReport(slug) {
      let url = `/customScreeners/${slug}`;
      this.$http.delete(url).then(() => {
        this.$store.dispatch("fetchCustomScreeners");
        if (slug === this.$store.getters.getScreenerId){
          this.loadScreener('BASIC', 'New Screen', false)
        }
      });
    },
  },
  computed: {
    cols() {
      let premiumScreeners = JSON.parse(JSON.stringify(this.$store.getters.getCustomScreeners)) || [];
      let col2 = premiumScreeners.splice(
        Math.ceil(premiumScreeners.length / 2)
      );
      return [premiumScreeners, col2];
    },
    selectedSlug() {
      return this.$store.getters.getScreenerId;
    },
  },
};
</script>